import { ERROR_ALLOWED_KEYS, IGNORED_TARGET, SLIDER_TARGET, SPACE_IGNORED_TARGET, VOLUME_STEP } from "./constants";

// Player-level keyboard shortcuts (Nova's handlePlayerKeyDown), active while focus is inside the player.
export function bindShortcuts(player) {
    const { root, cfg, state, actions } = player;

    root.addEventListener("keydown", e => {
        if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey) return;
        if (state.hasError && !ERROR_ALLOWED_KEYS.includes(e.key)) return;
        const target = e.target instanceof Element ? e.target : null;
        if (target && target.closest(IGNORED_TARGET)) return;

        const onSlider = target && target.closest(SLIDER_TARGET);
        const key = e.key;

        if (key === " ") {
            if (target && target.closest(SPACE_IGNORED_TARGET)) return;
            e.preventDefault();
            actions.togglePlay();
        } else if (key === "k" || key === "K") {
            e.preventDefault();
            actions.togglePlay();
        } else if (key === "ArrowLeft" || key === "ArrowRight") {
            if (onSlider || !player.isReady()) return;
            e.preventDefault();
            actions.skip(key === "ArrowLeft" ? -cfg.skip : cfg.skip);
        } else if (key === "ArrowUp" || key === "ArrowDown") {
            if (onSlider) return;
            e.preventDefault();
            actions.setVolume(state.volume + (key === "ArrowUp" ? VOLUME_STEP : -VOLUME_STEP));
        } else if (key === "Home" || key === "End") {
            if (onSlider || !player.isReady()) return;
            e.preventDefault();
            actions.seek(key === "Home" ? 0 : state.duration);
        } else if (key === "m" || key === "M") {
            e.preventDefault();
            actions.toggleMute();
        } else if (key === ",") {
            e.preventDefault();
            actions.stepPlaybackRate(-1);
        } else if (key === ".") {
            e.preventDefault();
            actions.stepPlaybackRate(1);
        }
    });
}
